export const bellsData = [
    { country: "Serbia", city: "Belgrade" },
    { country: "Turkey"},
    { country: "Ukraine", city: "Kiev" },
    { country: "United States", city: "Texas" },
    { country: "Canada", city: "Niagara Falls" },
    { country: "Japan", city: "Tokyo" },
    { country: "Cayman Islands"},
    { country: "Canada"},
    { country: "Brazil", city: "Rio de Janeiro" },
    { country: "Canada", city: "Toronto" },
    { country: "United States", city: "Michigan" },
    { country: "Czechia", city:"Karlovy Vary" },
    { country: "Georgia" },
    { country: "United Arab Emirates", city: "Abu Dhabi" },
    { country: "Egypt" },
    { country: "United States", city: "Virginia" },
    { country: "Canada", city: "Montreal" },
    { country: "United States", city: "Vermont" },
    { country: "United States", city: "Chicago" },
    { country: "Canada", city: "Ottawa" },
    { country: "Germany", city: "Hamburg" },
    { country: "Spain", city: "Cordoba" },
    { country: "Germany", city: "Frankfurt" },
    { country: "Morocco" },
    { country: "Greece", city: "Agios Nikolaos" },
    { country: "United States", city: "South Carolina" },
    { country: "Spain", city: "Barcelona" },
    { country: "Czechia", city: "Praha" },
    { country: "Italy", city: "Belagio" },
    { country: "Denmark"},
    { country: "Spain"},
    { country: "Bosnia and Herzegovina", city: "Sarajevo" },
    { country: "Italy", city: "Turino" },
    { country: "Sweden" },
    { country: "Netherlands", city: "Amsterdam" },
    { country: "Netherlands", city: "Amsterdam" },
    { country: "Ukraine" },
    { country: "Ukraine" },
    { country: "Spain", city: "Barcelona" },
    { country: "United States", city: "Washington D.C." },
    { country: "United States", city: "Charlotte" },
    { country: "United States", city: "Charlotte" },
    { country: "United States", city: "Charlotte" },
    { country: "United States", city: "Charlotte" },
    { country: "United States", city: "South Carolina" },
    { country: "United States", city: "South Carolina" },
    { country: "France", city: "Aveyron" },
    { country: "Switzerland" },
    { country: "Canada", city: "Niagara Falls" },
    { country: "Cuba"},
    { country: "United States", city: "North Carolina" },
    { country: "Thailand", city: "Bangkok" },
    { country: "Turkey", city: "Istanbul" },
    { country: "Belgium", city: "Antwerp" },
    { country: "Austria", city: "Vienna" },
    { country: "Belgium", city: "Brussels" },
    { country: "Netherlands"},
    { country: "Czechia", city: "Prague" },
    { country: "Canada", city: "Quebec" },
    { country: "United States", city: "North Carolina" },
    { country: "France", city: "Rodez" },
    { country: "Poland", city: "Warsaw" },
    { country: "Poland" },
    { country: "Bahrain" },
    { country: "Canada", city: "Niagara Falls" },
    { country: "Kenya" },
    { country: "Egypt" },
    { country: "Taiwan" },
    { country: "Croatia", city: "Zagreb" },
    { country: "United States", city: "Washington D.C." },
    { country: "France" },
    { country: "Morocco" },
    { country: "United States", city: "Virginia" },
    { country: "Cyprus" },
    { country: "France", city: "Paris" },
    { country: "Norway"},
    { country: "Lebanon" },
    { country: "Antigua and Barbuda" },
    { country: "Slovakia", city: "Bratislava" },
    { country: "Germany"},
    { country: "Brazil", city: "Rio de Janeiro" },
    { country: "United States", city: "San Francisco" },
    { country: "United States", city: "Philadelphia" },
    { special: "Ring for beer"},
    { country: "Nepal"},
    { country: "Romania"},
    { country: "United Arab Emirates", city: "Dubai" },
    { country: "Australia" },
    { country: "Malaysia" },
    { country: "Thailand" },
    { country: "Egypt" },
    { country: "Norway" },
    { country: "France", city: "Paris" },
    { country: "United Kingdom", city: "London" },
    { country: "Hong Kong" },
    { country: "Canada", city: "Quebec" },
    { country: "Qatar", city: "Doha" },
    { country: "Malaysia", city: "Langkawi" },
    { country: "Thailand"},
    { country: "United Arab Emirates", city: "Dubai" },
    { country: "United States", city: "Texas" },
    { country: "Cyprus" },
    { country: "Croatia", city: "Dubrovnik" },
    { country: "India" },
    { country: "Lebanon" },
    { country: "Costa Rica", city: "La Fortuna" },
    { country: "Australia"},
    { country: "Austria", city: "Vienna" },
    { country: "United States", city: "Georgia" },
    { country: "United States", city: "Las Vegas" },
    { country: "Turkey", city: "Istanbul" },
    { country: "United States", city: "San Diego" },
    { country: "France", city: "Paris" },
    { country: "Singapore" },
    { country: "Greece" },
    { country: "United States", city: "Myrtle Beach" },
    { country: "Serbia"},
    { country: "United States", city: "Philadelphia" },
    { country: "Denmark" },
    { country: "Italy", city: "Rome" },
    { country: "Singapore" },
    { country: "South Africa" },
    { country: "Spain", city: "Valencia" },
    { country: "Serbia"},
    { country: "Italy", city: "Rome" },
    { country: "United States", city: "Las Vegas" },
    { country: "Andorra" },
    { country: "Maldives" },
    { country: "Finland" },
    { country: "Georgia", city: "Tbilisi" },
    { country: "Slovakia", city: "Bratislava" },
    { country: "India" },
    { country: "United States", city: "San Diego" },
    { country: "United States", city: "Las Vegas" },
    { country: "United Arab Emirates", city: "Dubai" },
    { country: "Norway" },
    { country: "Norway" },
    { country: "Norway" },
    { country: "Iceland" },
    { country: "Germany", city: "Hamburg" },
    { country: "United Arab Emirates", city: "Abu Dhabi" },
    { country: "Colombia", city: "Santa Marta" },
    { country: "Lebanon" },
    { country: "Lebanon" },
    { country: "United Kingdom" },
    { country: "Lebanon" },
    { country: "China" },
    { special: "Ring for a kiss"},
    { country: "Switzerland" },
];

// Hardcoded coordinates for all bell locations (generated from Nominatim API)
export const bellCoordinates = {
    // Cities
    "Austria-Vienna": { latitude: 48.2083537, longitude: 16.3725042, displayName: "Vienna, Austria" },
    "Belgium-Antwerp": { latitude: 51.2211097, longitude: 4.3997081, displayName: "Antwerp, Belgium" },
    "Belgium-Brussels": { latitude: 50.8465573, longitude: 4.351697, displayName: "Brussels, Belgium" },
    "Bosnia and Herzegovina-Sarajevo": { latitude: 43.8570713, longitude: 18.4126147, displayName: "Sarajevo, Bosnia and Herzegovina" },
    "Brazil-Rio de Janeiro": { latitude: -22.9110137, longitude: -43.2093727, displayName: "Rio de Janeiro, Brazil" },
    "Canada-Niagara Falls": { latitude: 43.1065603, longitude: -79.0639039, displayName: "Niagara Falls, Canada" },
    "Canada-Toronto": { latitude: 43.6534817, longitude: -79.3839347, displayName: "Toronto, Canada" },
    "Canada-Montreal": { latitude: 45.5031824, longitude: -73.5698065, displayName: "Montreal, Canada" },
    "Canada-Ottawa": { latitude: 45.4208777, longitude: -75.6901106, displayName: "Ottawa, Canada" },
    "Canada-Quebec": { latitude: 52.4760892, longitude: -71.8258668, displayName: "Quebec, Canada" },
    "Colombia-Santa Marta": { latitude: 11.2320944, longitude: -74.1950916, displayName: "Santa Marta, Colombia" },
    "Costa Rica-La Fortuna": { latitude: 10.4716839, longitude: -84.644436, displayName: "La Fortuna, Costa Rica" },
    "Croatia-Zagreb": { latitude: 45.8130967, longitude: 15.9772795, displayName: "Zagreb, Croatia" },
    "Croatia-Dubrovnik": { latitude: 42.6491029, longitude: 18.0939501, displayName: "Dubrovnik, Croatia" },
    "Czechia-Karlovy Vary": { latitude: 50.2306216, longitude: 12.8701437, displayName: "Karlovy Vary, Czechia" },
    "Czechia-Praha": { latitude: 50.0874654, longitude: 14.4212535, displayName: "Praha, Czechia" },
    "Czechia-Prague": { latitude: 50.0874654, longitude: 14.4212535, displayName: "Prague, Czechia" },
    "France-Aveyron": { latitude: 44.3158574, longitude: 2.5065697, displayName: "Aveyron, France" },
    "France-Rodez": { latitude: 44.3511408, longitude: 2.5728493, displayName: "Rodez, France" },
    "France-Paris": { latitude: 48.8534951, longitude: 2.3483915, displayName: "Paris, France" },
    "Georgia-Tbilisi": { latitude: 41.6934591, longitude: 44.8014495, displayName: "Tbilisi, Georgia" },
    "Germany-Hamburg": { latitude: 53.550341, longitude: 10.000654, displayName: "Hamburg, Germany" },
    "Germany-Frankfurt": { latitude: 50.1106444, longitude: 8.6820917, displayName: "Frankfurt, Germany" },
    "Greece-Agios Nikolaos": { latitude: 35.1905899, longitude: 25.7175216, displayName: "Agios Nikolaos, Greece" },
    "Italy-Belagio": { latitude: 45.9777776, longitude: 9.2603359, displayName: "Bellagio, Lake Como, Italy" },
    "Italy-Turino": { latitude: 40.5346238, longitude: 16.3971055, displayName: "Turino, Italy" },
    "Italy-Rome": { latitude: 41.8933203, longitude: 12.4829321, displayName: "Rome, Italy" },
    "Japan-Tokyo": { latitude: 35.6768601, longitude: 139.7638947, displayName: "Tokyo, Japan" },
    "Malaysia-Langkawi": { latitude: 6.3700386, longitude: 99.7928634, displayName: "Langkawi, Malaysia" },
    "Netherlands-Amsterdam": { latitude: 52.3730796, longitude: 4.8924534, displayName: "Amsterdam, Netherlands" },
    "Poland-Warsaw": { latitude: 52.2333742, longitude: 21.0711489, displayName: "Warsaw, Poland" },
    "Qatar-Doha": { latitude: 25.2856329, longitude: 51.5264162, displayName: "Doha, Qatar" },
    "Serbia-Belgrade": { latitude: 44.8178131, longitude: 20.4568974, displayName: "Belgrade, Serbia" },
    "Slovakia-Bratislava": { latitude: 48.1516988, longitude: 17.1093063, displayName: "Bratislava, Slovakia" },
    "Spain-Cordoba": { latitude: 37.8845813, longitude: -4.7760138, displayName: "Cordoba, Spain" },
    "Spain-Barcelona": { latitude: 41.3825802, longitude: 2.177073, displayName: "Barcelona, Spain" },
    "Spain-Valencia": { latitude: 39.4697065, longitude: -0.3763353, displayName: "Valencia, Spain" },
    "Thailand-Bangkok": { latitude: 13.7524938, longitude: 100.4935089, displayName: "Bangkok, Thailand" },
    "Turkey-Istanbul": { latitude: 41.006381, longitude: 28.9758715, displayName: "Istanbul, Turkey" },
    "Ukraine-Kiev": { latitude: 50.4500336, longitude: 30.5241361, displayName: "Kiev, Ukraine" },
    "United Arab Emirates-Abu Dhabi": { latitude: 24.4538352, longitude: 54.3774014, displayName: "Abu Dhabi, United Arab Emirates" },
    "United Arab Emirates-Dubai": { latitude: 25.0742823, longitude: 55.1885387, displayName: "Dubai, United Arab Emirates" },
    "United Kingdom-London": { latitude: 51.4893335, longitude: -0.1440551, displayName: "London, United Kingdom" },
    "United States-Texas": { latitude: 31.2638905, longitude: -98.5456116, displayName: "Texas, United States" },
    "United States-Michigan": { latitude: 43.6211955, longitude: -84.6824346, displayName: "Michigan, United States" },
    "United States-Virginia": { latitude: 37.1232245, longitude: -78.4927721, displayName: "Virginia, United States" },
    "United States-Vermont": { latitude: 44.5990718, longitude: -72.5002608, displayName: "Vermont, United States" },
    "United States-Chicago": { latitude: 41.8755616, longitude: -87.6244212, displayName: "Chicago, United States" },
    "United States-South Carolina": { latitude: 33.6874388, longitude: -80.4363743, displayName: "South Carolina, United States" },
    "United States-Washington D.C.": { latitude: 38.8950368, longitude: -77.0365427, displayName: "Washington D.C., United States" },
    "United States-Charlotte": { latitude: 35.2272086, longitude: -80.8430827, displayName: "Charlotte, United States" },
    "United States-North Carolina": { latitude: 35.6729639, longitude: -79.0392919, displayName: "North Carolina, United States" },
    "United States-San Francisco": { latitude: 37.7792588, longitude: -122.4193286, displayName: "San Francisco, United States" },
    "United States-Philadelphia": { latitude: 39.9527237, longitude: -75.1635262, displayName: "Philadelphia, United States" },
    "United States-Georgia": { latitude: 32.3293809, longitude: -83.1137366, displayName: "Georgia, United States" },
    "United States-Las Vegas": { latitude: 36.1674263, longitude: -115.1484131, displayName: "Las Vegas, United States" },
    "United States-San Diego": { latitude: 32.7174202, longitude: -117.162772, displayName: "San Diego, United States" },
    "United States-Myrtle Beach": { latitude: 33.6956461, longitude: -78.8900409, displayName: "Myrtle Beach, United States" },

    // Countries
    "Andorra": { latitude: 42.5407167, longitude: 1.5732033, displayName: "Andorra" },
    "Antigua and Barbuda": { latitude: 17.2234721, longitude: -61.9554608, displayName: "Antigua and Barbuda" },
    "Australia": { latitude: -24.7761086, longitude: 134.755, displayName: "Australia" },
    "Bahrain": { latitude: 26.1551249, longitude: 50.5344606, displayName: "Bahrain" },
    "Canada": { latitude: 61.0666922, longitude: -107.991707, displayName: "Canada" },
    "Cayman Islands": { latitude: 19.7031822, longitude: -79.9174627, displayName: "Cayman Islands" },
    "China": { latitude: 35.000074, longitude: 104.999927, displayName: "China" },
    "Cuba": { latitude: 23.0131338, longitude: -80.8328748, displayName: "Cuba" },
    "Cyprus": { latitude: 34.9174159, longitude: 32.8899027, displayName: "Cyprus" },
    "Denmark": { latitude: 55.670249, longitude: 10.3333283, displayName: "Denmark" },
    "Egypt": { latitude: 26.2540493, longitude: 29.2675469, displayName: "Egypt" },
    "Finland": { latitude: 63.2467777, longitude: 25.9209164, displayName: "Finland" },
    "France": { latitude: 46.603354, longitude: 1.8883335, displayName: "France" },
    "Georgia": { latitude: 32.3293809, longitude: -83.1137366, displayName: "Georgia" },
    "Germany": { latitude: 51.1638175, longitude: 10.4478313, displayName: "Germany" },
    "Greece": { latitude: 38.9953683, longitude: 21.9877132, displayName: "Greece" },
    "Hong Kong": { latitude: 22.350627, longitude: 114.1849161, displayName: "Hong Kong" },
    "Iceland": { latitude: 64.9841821, longitude: -18.1059013, displayName: "Iceland" },
    "India": { latitude: 22.3511148, longitude: 78.6677428, displayName: "India" },
    "Kenya": { latitude: -0.1667169, longitude: 37.4860369, displayName: "Kenya" },
    "Lebanon": { latitude: 33.8750629, longitude: 35.843409, displayName: "Lebanon" },
    "Malaysia": { latitude: 4.5693754, longitude: 102.2656823, displayName: "Malaysia" },
    "Maldives": { latitude: 3.7203503, longitude: 73.2244152, displayName: "Maldives" },
    "Morocco": { latitude: 28.3347722, longitude: -10.3713379, displayName: "Morocco" },
    "Nepal": { latitude: 28.3780464, longitude: 83.9999901, displayName: "Nepal" },
    "Netherlands": { latitude: 52.2434979, longitude: 5.6343227, displayName: "Netherlands" },
    "Norway": { latitude: 61.1529386, longitude: 8.7876653, displayName: "Norway" },
    "Poland": { latitude: 52.215933, longitude: 19.134422, displayName: "Poland" },
    "Romania": { latitude: 45.9852129, longitude: 24.6859225, displayName: "Romania" },
    "Serbia": { latitude: 44.0243229, longitude: 21.0765743, displayName: "Serbia" },
    "Singapore": { latitude: 1.357107, longitude: 103.8194992, displayName: "Singapore" },
    "South Africa": { latitude: -28.8166236, longitude: 24.991639, displayName: "South Africa" },
    "Spain": { latitude: 39.3260685, longitude: -4.8379791, displayName: "Spain" },
    "Sweden": { latitude: 59.6749712, longitude: 14.5208584, displayName: "Sweden" },
    "Switzerland": { latitude: 46.7985624, longitude: 8.2319736, displayName: "Switzerland" },
    "Taiwan": { latitude: 23.9739374, longitude: 120.9820179, displayName: "Taiwan" },
    "Thailand": { latitude: 14.8971921, longitude: 100.83273, displayName: "Thailand" },
    "Turkey": { latitude: 39.294076, longitude: 35.2316631, displayName: "Turkey" },
    "Ukraine": { latitude: 49.4871968, longitude: 31.2718321, displayName: "Ukraine" },
    "United Kingdom": { latitude: 54.7023545, longitude: -3.2765753, displayName: "United Kingdom" }
};

// Helper function to get coordinates for a bell
export const getCoordinatesForBell = (bell) => {
    if (bell.special) return null;
    if (!bell.country) return null;
    
    const key = bell.city ? `${bell.country}-${bell.city}` : bell.country;
    const coordinates = bellCoordinates[key];
    
    if (coordinates) {
        return {
            ...bell,
            latitude: coordinates.latitude,
            longitude: coordinates.longitude,
            displayName: coordinates.displayName,
            isCity: !!bell.city
        };
    }
    
    return null;
};

// Get unique countries from bell data
export const getUniqueCountries = (bellsData) => {
    const countrySet = new Set();
    bellsData.forEach(bell => {
        if (bell.country && !bell.special) {
            countrySet.add(bell.country);
        }
    });
    return Array.from(countrySet);
};

// Separate city bells from country-only bells
export const separateCityAndCountryBells = (bellsWithCoordinates) => {
    const cityBells = bellsWithCoordinates.filter(bell => bell.isCity);
    const countryBells = bellsWithCoordinates.filter(bell => !bell.isCity);
    return { cityBells, countryBells };
};

